<template>
  <div
    class="ws-main"
    :style="[{'padding-bottom':'240px'}]"
  >
    <WsBreadCrumbs :items="_breadcrumbsItems"></WsBreadCrumbs>
    <WsTitle>新增{{label}}</WsTitle>
    <div class="ws-content-section">
      <ValidationObserver
        ref="form"
        class="ws-content-section-observer"
      >
        <v-form
          ref="createForm"
          @submit.prevent
        >
          <div
            class="ws-content-section"
            v-if="!loading"
          >
            <div class="ws-content-section__primary">
              <WsStateContentBlock
                v-for="(item,itemKey) in primary"
                ref="primaryContentBlock"
                :key="itemKey"
                :type="item.type"
                :label="item.label"
                :title="item.title"
                :remark="item.remark"
                :floors="item.floors"
                :modedFields="_updateFields"
                :fields="item.fields"
                :field="item.field"
                :modelName="item.modelName"
                :modeVersions="item.modeVersions"
                :modeParent="item.modeParent"
                :customButtons="item.customButtons"
                :fieldsRead="item.fieldsRead"
                :updateData="createData"
                :customParentData="_customParentData"
                :itemVersionCreatable="itemVersionCreatable"
                :itemVersionLinkCreatable="itemVersionLinkCreatable"
                :itemVersionReadable="itemVersionReadable"
                :itemDeletable="itemDeletable"
                :itemEditable="itemEditable"
                :itemLinkCheckable="itemLinkCheckable"
                :titleKey="item.titleKey"
                :locale="_selectingLocale"
                :orderWay="item.orderWay"
                :orderBy="item.orderBy"
                :isGetAll="item.isGetAll"
                :params="$_getParams(item.isGetAll)"
                :parentState="$_getParentState(item)"
                :groupSaving="item.groupSaving"
                :modelData="parentModelData"
                :articleSaving="item.articleSaving"
                :parentModelName="$_getParentModelName(item)"
                :postData="$_getPostData(item)"
                :getUrl="item.getUrl"
                :customSubmitModelDatasAction="item.customSubmitModelDatasAction"
                @input="$_onInput($event)"
                @groupSave="$_groupSaveArr($event)"
                @fetch="$emit('fetch', $event)"
              ></WsStateContentBlock>
            </div>
            <div class="ws-content-section__secondary">
              <WsStateContentBlock
                v-for="(item,itemKey) in secondary"
                ref="secondaryContentBlock"
                :key="itemKey"
                :type="item.type"
                :label="item.label"
                :title="item.title"
                :remark="item.remark"
                :floors="item.floors"
                :modedFields="_updateFields"
                :fields="item.fields"
                :field="item.field"
                :modelName="item.modelName"
                :modeVersions="item.modeVersions"
                :modeParent="item.modeParent"
                :customButtons="item.customButtons"
                :fieldsRead="item.fieldsRead"
                :updateData="createData"
                :customParentData="_customParentData"
                :locale="_selectingLocale"
                :modelData="parentModelData"
                @input="$_onInput($event)"
                :parentModelName="$_getParentModelName(item)"
              ></WsStateContentBlock>
            </div>
          </div>
        </v-form>
      </ValidationObserver>
    </div>
    <WsMainBottomNav>
      <WsBtn
        v-if="!customBtns.isHideRegularBtns"
        @click="$router.go(-1)"
        color="textSecondary"
        outlined
      >取消</WsBtn>
      <WsBtn
        v-if="!customBtns.isHideRegularBtns"
        @click="$_onSubmit()"
        :loading="submitLoading"
      >送出</WsBtn>
      <WsBtn
        v-for="(btn, btnKey) in customBtns.btns"
        :key="btnKey"
        @click="$_onCustomBtnClicked(btn)"
        :color="btn.color"
        :outlined="btn.outlined"
      >
        {{btn.title}}
      </WsBtn>
    </WsMainBottomNav>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data: () => ({
    isMounted: false,
    parentModelData: null,
    createData: {},
    submitLoading: false,
    loading: true,
    groupSaveArr: [],
  }),
  methods: {
    $_onInput($event) {
      this.createData = {
        ...this.createData,
        ...$event,
      };
      this.$emit("input", this.createData);
    },
    async $_onSubmit() {
      const isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return;
      }
      this.submitLoading = true;
      try {
        let postUrl;
        if (this.parentModelName && this.parentId) {
          postUrl = `/${this.parentModelName}/${this.parentId}/${this.modelName}`;
        } else {
          postUrl = `/${this.modelName}`;
        }
        const postData = JSON.parse(JSON.stringify(this.createData));
        if (this.customCreateAction) {
          this.customCreateAction(postData);
        }
        const res = await this.$axios.post(postUrl, postData);
        const tasks = [];
        let hasGroupSaving = false;
        this.primary.forEach((priItem, priIndex) => {
          if (priItem.groupSaving && priItem.type === "expandList") {
            hasGroupSaving = true;
            this.parentModelData.last_version.id = res.data.data.id;
            tasks.push(
              this.$refs.primaryContentBlock[priIndex].$_onPropsData()
            );
          }
        });

        this.secondary.forEach((secItem, secIndex) => {
          if (secItem.groupSaving && secItem.type === "expandList") {
            hasGroupSaving = true;
            this.parentModelData.last_version.id = res.data.data.id;
            tasks.push(
              this.$refs.secondaryContentBlock[secIndex].$_onPropsData()
            );
          }
        });
        await Promise.all(tasks);
        if (hasGroupSaving) {
          let newVersionData = {};
          newVersionData.article_versions = this.groupSaveArr;
          await this.$axios.patch(
            `/${this.modelName}/${this.parentModelData.last_version.id}`,
            newVersionData
          );
        }
        if (this._updateFields.last_version) {
          try {
            let newObj = {};
            newObj = postData.last_version;
            if (this.hasSequence || this.hasChapters) {
              newObj.version_status = 1;
            }
            if (this.hasCatchVersion) {
              newObj[this.modelName] = res.data.data.id;
              await this.$axios.post(`/${this._versionModelName}`, newObj);
            } else {
              await this.$axios.post(
                `/${this.modelName}/${res.data.data.id}/${this._versionModelName}`,
                newObj
              );
            }
            this.submitLoading = false;
          } catch (error) {
            alert("版本儲存發生錯誤");
            this.submitLoading = false;
          }
        }
        this.$store.dispatch('app/stopNeedSave');
        const redirectUrl = this.$route.query && this.$route.query.redirect
          ? this.$route.query.redirect
          : this.parentModelName && this.parentId
          ? `/${this.parentModelName}/${this.parentId}`
          : `/${this.modelName}`;
        this.$router.push(redirectUrl);
      } catch (error) {
        if (error.response && error.response.status === 400) {
          let errorMessage =[]
          if (typeof error.response.data.message === 'object') {
            if (Array.isArray(error.response.data.message)) {
              for (let errors of error.response.data.message) {
                errorMessage.push(this.$locales[errors])
              }
            } else {
              for (let errors in error.response.data.message) {
                errorMessage.push(this.$locales[error.response.data.message[errors]])
              }
            }
          } else {
            errorMessage.push(this.$locales[error.response.data.message])
          }
          alert(errorMessage)
        } else {
          alert(error, "儲存錯誤");
        }
        this.submitLoading = false;
      }
    },
    $_getParentModelName(primaryItem) {
      if (primaryItem.modeVersions && this.modelName.indexOf("version") == -1) {
        return `${this.modelName}_version`;
      } else {
        return this.modelName;
      }
    },
    async $_parentFetchData() {
      if (!this.parentModelName && !this.parentId) return;
      this.loading = true;
      this.$store.dispatch("app/startPageLoading");
      let getUrl = `/${this.parentModelName}/${this.parentId}`;
      try {
        const res = await this.$axios.get(getUrl);
        this.parentModelData = res.data.data;
        this.$emit('fetch-parent-model-data', this.parentModelData);
        if (this.staticModelData) {
          this.staticModelData(this.modelData, this.fields);
        }
        this.loading = false;
      } catch (error) {
        alert(error);
      } finally {
        this.$store.dispatch("app/stopPageLoading");
      }
    },
    $_getParentState(primaryItem) {
      if (!this.parentModelData) return;
      if (primaryItem.modeParentVersions && this.parentModelData.last_version) {
        return this.parentModelData.last_version.id;
      } else {
        return this.parentModelData.id;
      }
    },
    $_getPostData(item) {
      if (!this.parentModelData) return;
      let _params = {};
      if (this.parentModelData && this.modelName.indexOf("version") != -1) {
        _params[`${this.parentModelName}`] = this.parentModelData.id;
      }
      if (item.modeParentVersions) {
        _params[`${this.modelName}`] = this.$_getParentState(item);
      }
      return _params;
    },
    $_getParams(isGetAll) {
      if (!this.parentModelData) return;
      let _params = {};
      _params[`${this.modelName}s`] = this.parentModelData.last_version.id;
      if (isGetAll) _params.get_all = true;
      return _params;
    },
    $_groupSaveArr($event) {
      this.groupSaveArr = $event;
      this.$emit("group-save", this.groupSaveArr)
    },
    async $_onCustomBtnClicked(btn) {
      if (btn.isValidateForm){
        const isValidate = await this.$refs.form.validate();
        if (!isValidate) {
          return;
        }
      }
      if (btn.emit) {
        this.$emit(btn.emit, {createData: this.createData})
      }
    },
    async $_onPropsData(id, versionStatus){
      for (let item of this.primary) {
        const index = this.primary.findIndex(_item=> _item == item)
        if (item.groupSaving && item.type === "expandList") {
          this.parentModelData.last_version.id = id;
          if ( versionStatus === 0 ) this.parentModelData.last_version.version_status = versionStatus;
          await this.$refs.primaryContentBlock[index].$_onPropsData()
        }
      }
      for (let item of this.secondary) {
        const index = this.secondary.findIndex(_item=> _item == item)
        if (item.groupSaving && item.type === "expandList") {
          this.parentModelData.last_version.id = id;
          await this.$refs.secondaryContentBlock[index].$_onPropsData()
        }
      }
    }
  },
  computed: {
    _customParentData() {
      if (this.customParentData) {
        return this.customParentData(this.createData, this.parentModelData);
      } else {
        return null;
      }
    },
    _parentTitle() {
      if (!this.parentModelName) {
        return null;
      } else if (!this.parentModelData) {
        return this.parentLabel;
      } else {
        return this.$_CMS_getValueByFieldKey(
          this.parentTitleKey,
          this.parentModelData
        );
      }
    },
    _breadcrumbsItems() {
      const _breadcrumbsItems = [];
      if (
        this.parentModelName &&
        this.parentId &&
        this.parentLabel &&
        this.parentTitleKey
      ) {
        _breadcrumbsItems.push({
          text: this.parentLabel,
          to: `/${this.parentModelName}`,
          disabled: false,
        });
        _breadcrumbsItems.push({
          text: this._parentTitle,
          to: `/${this.parentModelName}/${this.parentId}`,
          disabled: false,
        });
      }
      _breadcrumbsItems.push({
        text: `新增${this.label}`,
        disabled: true,
      });
      return _breadcrumbsItems;
    },
    _versionModelName() {
      if (this.modelVersionName) {
        return this.modelVersionName;
      }
      if (this.modelName.indexOf("version") !== -1) {
        return this.modelName;
      } else return `${this.modelName}_version`;
    },
    _updateFields() {
      return this.$_CMS_geUpdateFields(this.fields);
    },
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
  },
  props: {
    staticModelData: {
      type: Function,
    },
    parentTitleKey: {
      type: String,
      default: null,
    },
    parentLabel: {
      type: String,
      default: null,
    },
    parentId: {
      type: [String, Number],
      default: null,
    },
    parentModelName: {
      type: String,
      default: null,
    },
    primary: {
      type: Array,
      default() {
        return [];
      },
    },
    secondary: {
      type: Array,
      default() {
        return [];
      },
    },
    hasSequence: {
      type: Boolean,
      default: false,
    },
    hasChapters: {
      type: Boolean,
      default: false,
    },
    modelName: String,
    label: String,
    fields: Object,
    hasCatchVersion: {
      type: Boolean,
      default: false,
    },
    customParentData: {
      type: Function,
    },
    itemDeletable: {
      type: Boolean,
    },
    itemEditable: {
      type: Boolean,
    },
    itemLinkCheckable: {
      type: Boolean,
    },
    itemVersionLinkCreatable: {
      type: Boolean,
    },
    itemVersionCreatable: {
      type: Boolean,
    },
    itemVersionReadable: {
      type: Boolean,
    },
    submodelName: {
      type: String,
      default: "",
    },
    articleSaving: {
      type: Boolean,
      default: false,
    },
    modelVersionName: {
      type: String,
      default: "",
    },
    customCreateAction: {
      type: Function,
    },
    customBtns: {
      type: Object,
      default:function(){
        return {
          isHideRegularBtns: false
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch("locale/changeLanguageDisable");
    if (this.parentModelName && this.parentId) {
      this.$_parentFetchData();
    } else {
      this.loading = false;
    }
    // this.$_CMS_updateDataSetFromFields(
    //   this,
    //   this.createData,
    //   this._updateFields
    // );
    setTimeout(() => {
      this.isMounted = true;
    }, 0);
  },
  watch: {
    createData: {
      handler() {
        if (this.isMounted) {
          this.$store.dispatch("app/startNeedSave");
        }
      },
      deep: true,
    },
  },
};
</script>